import { render, staticRenderFns } from "./CustomerRouteNonGTDetail.vue?vue&type=template&id=5d9b0b7e&"
import script from "./CustomerRouteNonGTDetail.vue?vue&type=script&lang=js&"
export * from "./CustomerRouteNonGTDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports